<template>
<!-- eslint-disable max-len -->
<list-page
  :name="classTypeName"
  :plural="classTypeNamePlural"
  use="_id"
  :display="display"
  page-prefix="/blade/classes"
  :fetch="getClasses"
  :sort-options="sortOptions"
  :sort-functions="sortFunctions"
  :default-sort="defaultSort"
></list-page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import ListPage from '../../ui/pages/ListPage';

export default {
  components: {
    ListPage
  },
  data() {
    return {
      sortOptions: ['Gamulation', 'Last Updated'],
      sortFunctions: [this.gameSort, this.updatedSort],
      defaultSort: 1,
    };
  },
  computed: {
    ...mapGetters([
      'classTypeName',
      'classTypeNamePlural',
    ]),
  },
  methods: {
    ...mapActions([
      'getClasses',
    ]),
    display({
      className, courseName, courseIdentifier,
      year, season, section,
      updated, fetchedGame
    }) {
      const date = updated && new Date(updated);
      const dateString = date && ` (edited ${date.toLocaleDateString()} ${date.toLocaleTimeString()})` || '';
      const associationString =
        ((fetchedGame != null) ? ` (${fetchedGame})` : '');
      return `${className} [${courseIdentifier}: ${courseName}]\n(${season} ${year} ${section})${associationString}${dateString}`;
    },
    gameSort(a, b) {
      const aAssignedGameName =
        (a.fetchedGame == null || a.fetchedClass != null)
          ? ''
          : a.fetchedGame.toLocaleLowerCase();
      const bAssignedGameName =
        (b.fetchedGame == null || b.fetchedClass != null)
          ? ''
          : b.fetchedGame.toLocaleLowerCase();
      if (aAssignedGameName === '' && bAssignedGameName !== '') return 1;
      if (aAssignedGameName !== '' && bAssignedGameName === '') return -1;
      return ((aAssignedGameName < bAssignedGameName)
        ? -1
        : ((aAssignedGameName > bAssignedGameName) ? 1 : 0));
    },
    updatedSort(a, b) {
      if (a.updated == null && b.updated == null) return 0;
      if (a.updated == null) return 1;
      if (b.updated == null) return -1;
      return (a.updated > b.updated) ? -1 : ((a.updated < b.updated) ? 1 : 0);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/blade/pages/ClassList.vue